import { Column, Divider, Row, Text } from '~/commonComponents';
import { JobPostingStatus } from '~/domain/PermanentJobs';
import { WarningSolidIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';

interface ISuspendedBannerProps {
  jobStatus: JobPostingStatus;
}

export const SuspendedBanner = ({ jobStatus }: ISuspendedBannerProps) => {
  if (jobStatus !== JobPostingStatus.Suspended) {
    return null;
  }

  return (
    <Row
      alignItems="center"
      backgroundColor={Colors.warning_30}
      borderColor={Colors.warning_700}
      borderRadius={6}
      borderStyle="solid"
      borderWidth={1}
      gap={12}
      marginTop={20}
      paddingBlock={12}
      paddingInline={10}
    >
      <WarningSolidIcon color={Colors.warning_500} size={24} />
      <Divider height="95%" width={1} color={Colors.warning_500} />
      <Column>
        <Text bold color={Colors.warning_700} marginBottom={4}>
          This Job Posting Is Suspended:
        </Text>
        <Text color={Colors.warning_700}>
          Candidates can no longer view or apply to this job. Onsite Interviews within 7<br />
          days will remain active. All others have been canceled.
          <br />
          You can reactivate this posting by updating your payment method within the next
          <br />
          [X] days before it’s permanently closed.
        </Text>
      </Column>
    </Row>
  );
};
